import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from '../components/login';
import Master from './Master';
import { getAuthState } from '../assets/scripts/login-util';
import { redirectToLogout } from '../components/api/common';
import VideoCall from '../components/videocall';
import VideoCallClient from '../components/videocallClient';

const App = () => { 
    const [auth,            setAuth]                    = useState(getAuthState('bool'));

    useEffect(() => {
        const authorized = getAuthState('bool');
        if (authorized === 'Expired') redirectToLogout()
        else {
           setAuth(authorized);
        }
    }, []);

    const authHandler = async () => {
        const authorized = getAuthState('bool');
        authorized === 'Expired' ? setAuth(false) : setAuth(authorized);
    }

    return (
        <BrowserRouter>
        {auth ? (
            <Switch>
                <Route path="/videocall" exact>
                    <VideoCall />
                </Route>
                <Route path="/videocall-client" exact>
                    <VideoCallClient />
                </Route>
                <Master auth={auth} />
            </Switch>
        ) : (
            <Switch>
                <Route path="/login" exact>
                    <Login onLogin={authHandler} />
                </Route>
                <Route path="/videocall-client" exact>
                    <VideoCallClient />
                </Route>
                <Redirect to="/login" />
            </Switch>
        )}
        </BrowserRouter>
    )
}

export default App;